// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609150004/js/" + chunkId + "." + {"44":"42f20254","225":"c67d9066","481":"111021bd","486":"fae5dd36","770":"7b135f11"}[chunkId] + ".0.6588637091649687.chunk.js";
};